"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedVenueDto = exports.FEATURED_VENUES_CHECKINS_WINDOW_DAYS = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
/** Check-ins window behind FeaturedVenueDto.recentCheckins (the 30 full days before today). */
exports.FEATURED_VENUES_CHECKINS_WINDOW_DAYS = 30;
/** Public venue card for the landing page "Where will you meet?" section. */
class FeaturedVenueDto {}
exports.FeaturedVenueDto = FeaturedVenueDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], FeaturedVenueDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], FeaturedVenueDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueType
}), __metadata("design:type", String)], FeaturedVenueDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Uploaded venue logo, or the default icon for the venue type when none is uploaded.'
}), __metadata("design:type", String)], FeaturedVenueDto.prototype, "logoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Venue has an uploaded logo (partner venue).'
}), __metadata("design:type", Boolean)], FeaturedVenueDto.prototype, "isPartnerVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Check-ins in the 30 full days before today (based on Visit.checkedInAt).'
}), __metadata("design:type", Number)], FeaturedVenueDto.prototype, "recentCheckins", void 0);
//# sourceMappingURL=FeaturedVenue.dto.js.map